import { useQuery } from "@apollo/client";
import { getItem } from "../../utility/localStorageControl";

import {
  GET_BRANCH_OFICCES,
  GET_CAR_OWNERS,
  GET_CAR_RENTERS,
  GET_ALL_CARS,
} from "../../graphql/AdminQueries";

const GetSelectData = (graphqlVariables, loadData) => {
  const branchOfices = useQuery(GET_BRANCH_OFICCES, {
    variables: graphqlVariables,
    skip: !loadData,
  });
  const carOwners = useQuery(GET_CAR_OWNERS, {
    variables: graphqlVariables,
    skip: !loadData,
  });

  const carRenters = useQuery(GET_CAR_RENTERS, {
    variables: graphqlVariables,
    skip: !loadData,
  });
  return [branchOfices, carOwners, carRenters];
};

const GetAllCars = (graphqlVariables, loadData) => {
  const user = getItem("user");
  const variables = { ...graphqlVariables };
  // user.role can be string; normalize to number
  if (Number(user?.role) !== 1) {
    const branchOfficeId = user?.branchOffice?.id;
    if (branchOfficeId !== undefined && branchOfficeId !== null) {
      const n = Number(branchOfficeId);
      if (Number.isFinite(n) && n > 0) {
        variables.branchOffice = n;
      }
    }
  }
  const carsData = useQuery(GET_ALL_CARS, {
    variables,
    skip: !loadData,
  });
  return [carsData];
};

export { GetSelectData, GetAllCars };
